import { Network } from '@/utils/network'

import urls from '../urls.json'

async function getFees(userId) {
  const response = await sendRequest(userId)
  const parsedResponse = parseResponse(response)
  return parsedResponse
}

async function sendRequest(userId) {
  let url = `${urls.getFees}${userId}`
  const response = await Network.sendGetRequest(url)
  return response
}

function parseResponse(response) {
  if (
    response &&
    response.status.code === 200 &&
    response?.response?.statusCode == 200
  ) {
    const data = response.response.data

    return {
      statusCode: 200,
      data: data,
    }
  }
  return {
    statusCode: 404,
    message: 'store not found',
  }
}

export { getFees }
